
import ImageText from '../image-text';
import { Helmet } from 'react-helmet-async';

import './edtech.scss';

const EdTech = () => {
  return (
    <>
      <Helmet>
        <title>EdTech Solutions | Watchelm</title>
        <meta name="description" content="Discover our EdTech solutions designed to empower education providers with the technology they need." />
      </Helmet>
      <div className="flow-page">

        {/* First Feature section */}
        <div className="section-container">  

          {/* Consulting services sections using ImageText components */}
          <ImageText 
            title="Serving Education Providers"
            subtitle="Automating your technology requirements"
            content={`<p>Our EdTech solutions empower training providers with the technical infrastructure 
            and expertise needed to deliver exceptional learning experiences. We recognise that many 
            training organisations do not have the technical expertise in house, or the time to set up 
            and manage their technology platform.</p>

            <p>From learning management systems and content delivery platforms to AI-powered assessment 
            tools and cloud-based training environments, we provide the technical backbone that makes 
            modern education possible. We understand the unique challenges facing training organizations today.</p>

            <p>Our solutions are designed to scale with your business, integrate seamlessly with your 
            existing systems, and enhance your ability to deliver impactful learning outcomes. Whether 
            you need custom platform development, technical consulting, or ongoing support, we're your 
            trusted technology partner.</p>`}
            imageSrc="/assets/images/optimized/EdTech/image4"
            imageAlt="EdTech Services"buttonText="Enquire Now"
            buttonLink="/contact#subject=edtech"
            imageOnRight={false}
            gradientTitle="red-to-green"
          />
      </div>
      {/* Zigzag connector to the right */}
      <div className="section-connector zigzag-right">
        {/* Arrow head removed */}
      </div>
    
    {/* Second Feature section*/}
    <div className="section-container">
      <ImageText 
        title="Instructor Provisioning and Management"
        subtitle="Need an instructor?"
        content={`<p>Our instructor provisioning and management solutions help training providers build
        and maintain world-class teaching teams. From sourcing specialized technical instructors to        managing scheduling, performance tracking, and ongoing development, we streamline the complex 
        process of instructor management so you can focus on delivering exceptional training programs.
        </p>
        <p>We understand that finding qualified instructors in emerging technologies like Generative AI 
        and Cloud Computing can be challenging. Our comprehensive approach includes instructor recruitment, 
        skills assessment, onboarding support, and ongoing performance management. Whether you need to rapidly 
        scale your instructor pool or enhance your existing team's capabilities, we provide the expertise and 
        systems to ensure consistent, high-quality delivery across all your programs.</p>`}
        imageSrc="/assets/images/optimized/EdTech/image3" 
        imageAlt="Instructor Teaching"buttonText="Contact Our Experts"
        buttonLink="/contact#subject=edtech"
        imageOnRight={true}
        backgroundColor="#f8f9fa"
        gradientTitle="red-to-green"
      />
    </div>
    </div>
    </>

  );
}

export default EdTech;
